import LegalLayout from "../components/LegalLayout";

const H = ({ children }) => <h2 className="font-heading text-xl mt-8 mb-2">{children}</h2>;
const P = ({ children }) => <p className="text-muted-foreground">{children}</p>;
const Table = ({ rows }) => (
  <div className="border border-white/10 rounded-lg overflow-hidden mt-3">
    <table className="w-full text-sm">
      <thead className="bg-white/5 text-left">
        <tr>
          <th className="p-3">Name</th>
          <th className="p-3">Type</th>
          <th className="p-3">Purpose</th>
          <th className="p-3">Duration</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-white/5">
        {rows.map((r, i) => (
          <tr key={i} className="text-muted-foreground">
            <td className="p-3 font-mono text-xs text-foreground">{r[0]}</td>
            <td className="p-3">{r[1]}</td>
            <td className="p-3">{r[2]}</td>
            <td className="p-3">{r[3]}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const CookiePolicy = () => (
  <LegalLayout title="Cookie Policy" lastUpdated="19 February 2026">
    <P>This Cookie Policy explains how Vivo Musician Management uses cookies and similar browser-storage technologies.</P>

    <H>1. What we use</H>
    <P>Vivo currently uses <strong>strictly necessary</strong> storage only. We do not use analytics, advertising, or tracking cookies, and we do not embed third-party cookies.</P>

    <Table rows={[
      ["token", "localStorage", "Your login session (JSON Web Token). Without this you would have to sign in on every page.", "Until you log out"],
      ["user", "localStorage", "A cached copy of your basic profile (name, role, current band) so the UI renders instantly.", "Until you log out"],
      ["vivo-cookie-consent", "localStorage", "Records that you&apos;ve seen and acknowledged this banner so we don&apos;t show it on every visit.", "1 year"],
    ]} />

    <H>2. Why we don&apos;t need your consent for these</H>
    <P>Under the Privacy and Electronic Communications Regulations (PECR), strictly necessary cookies do not require opt-in consent because without them the service you explicitly requested (a logged-in web app) cannot function. We still surface them here for transparency, and we show a short banner on your first visit so you have full visibility.</P>

    <H>3. Third-party services that may set their own cookies</H>
    <P>Some third parties set cookies only when you interact with them, not when you browse Vivo:</P>
    <ul className="list-disc ml-5 space-y-1.5 text-muted-foreground">
      <li><strong>Stripe</strong> — only if your band admin goes to the Subscription page and opens the Stripe checkout.</li>
      <li><strong>Google Drive</strong> — only if you click &ldquo;Open in Drive&rdquo; on a document and are signed into Google.</li>
      <li><strong>Google Maps</strong> — only if you click on an event location to open the Maps link.</li>
    </ul>
    <P>These are covered by each provider&apos;s own privacy policy.</P>

    <H>4. How to disable cookies</H>
    <P>Because Vivo only uses strictly necessary storage, disabling it via your browser settings will prevent you from logging in. You can clear the storage at any time from your browser&apos;s developer tools or privacy settings.</P>

    <H>5. Changes</H>
    <P>If we ever add optional analytics or marketing cookies we will update this page and ask for your opt-in consent via the banner.</P>

    <H>6. Contact</H>
    <P>Questions? Email <a className="text-primary" href="mailto:james@support.vivomusicianmanagement.co.uk">james@support.vivomusicianmanagement.co.uk</a>.</P>
  </LegalLayout>
);

export default CookiePolicy;
